/* globals getExtensionAssetsPath */
define('CustomProductCollection.Model', [
    'SCModel',
    'Utils',
    'jQuery',
    'underscore'
], function CustomProductCollectionModelModule(
    SCModelComponent,
    Utils,
    jQuery,
    _
) {
    'use strict';

    var SCModel = SCModelComponent.SCModel;

    /**
     * Model for custom product collections, maintains child selection and dynamic item fetching.
     * @constructor
     * @param {Object} attributes - Should include:
     *    - productDetailsFields (Array)
     *    - searchComponent (Object with getUrl())
     *    - cartComponent (Object, for addLine)
     *    - ...payload for base SCModel, excluding above keys
     */
    function CustomProductCollectionModel(attributes) {
        this.productDetailsFields = attributes.productDetailsFields;
        this.searchComponent = attributes.searchComponent;
        // cartComponent is needed later to add child items to the cart
        this.cartComponent = attributes.cartComponent;

        SCModel.call(
            this,
            _(attributes).omit('searchComponent', 'cartComponent', 'productDetailsFields')
        );

        /**
         * Returns SuiteScript2 service endpoint for sync.
         * @returns {string}
         */
        this.urlRoot = function urlRoot() {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    'Modules/Main/SuiteScript2/CustomProductCollection.Model.Service.ss'
                ),
                true
            );
        };

        this.on('sync', this.onSync);
    }

    CustomProductCollectionModel.prototype = Object.create(SCModel.prototype);
    CustomProductCollectionModel.prototype.constructor = CustomProductCollectionModel;

    /**
     * Callback for 'sync' event, triggers item info fetch for child items.
     * Will update 'childrenItemData' on model if successful.
     * @param {CustomProductCollectionModel} model
     * @param {Object} data
     */
    CustomProductCollectionModel.prototype.onSync = function onSync(model, data) {
        var itemAPIUrl;
        var childrenDisplayOptions;

        if (!data || !data.children || !data.children.length) {
            return;
        }

        itemAPIUrl = this.searchComponent.getUrl({
            id: data.children.join(','),
            fieldset: 'custom_product_collection'
        });
        childrenDisplayOptions = data.childrenDisplayOptions || {};

        jQuery.ajax(itemAPIUrl).done(function afterItemAPICall(itemAPIResult) {
            if (itemAPIResult && itemAPIResult.items) {
                model.set(
                    'childrenItemData',
                    _.chain(itemAPIResult.items)
                        .map(function addDisplayOptions(itemData) {
                            var displayOptions =
                                childrenDisplayOptions[String(itemData.internalid)] || {};

                            return _.extend({}, itemData, {
                                showImage: displayOptions.showImage !== false
                            });
                        })
                        .sortBy(function sortBy(itemData) {
                            return data.children.indexOf(String(itemData.internalid));
                        })
                        .value()
                );
            }
        });
    };

    /**
     * Set the currently selected child item.
     * @param {string|number} childId
     */
    CustomProductCollectionModel.prototype.selectChild = function selectChild(childId) {
        this.set('selectedChild', childId);
    };

    /**
     * Get the currently selected child item.
     * @returns {string|number}
     */
    CustomProductCollectionModel.prototype.getSelectedChild = function getSelectedChild() {
        return this.get('selectedChild');
    };

    // Return the model constructor.
    return CustomProductCollectionModel;
});
